//floating-point precision errors in JavaScript. JavaScript uses IEEE 754 double-precision for numbers, which can introduce tiny inaccuracies in calculations.
//We were noticing 646.275 was rounding to 646.27 instead of 646.28. This is because 646.275 is actually stored as 646.2749999999999772626324556767940521240234375 in JavaScript.
//This fixes the penny issue
//https://cargomatic.atlassian.net/browse/CARGO-11473

export const roundTo = (num, decimals) => {
    const factor = 10 ** decimals;
    return Math.round((num + Number.EPSILON) * factor) / factor;
}
